var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FB6340",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910,410 C633.857625,410 410,633.857625 410,910 C410,1042.60824 462.67842,1169.7852 556.446609,1263.55339 C650.214799,1357.32158 777.391755,1410 910,1410 C1042.60824,1410 1169.7852,1357.32158 1263.55339,1263.55339 C1357.32158,1169.7852 1410,1042.60824 1410,910 C1410,852 1399.5,794.5 1379.5,740.5 L1299.5,820.5 C1306.5,850 1310,880 1310,910 C1310,1130.9139 1130.9139,1310 910,1310 C689.0861,1310 510,1130.9139 510,910 C510,689.0861 689.0861,510 910,510 C940,510 970,513.5 999.5,520.5 L1080,440 C1025.5,420.5 968,410 910,410 M1260,410 L1060,610 L1060,685 L932.5,812.5 C925,810 917.5,810 910,810 C854.771525,810 810,854.771525 810,910 C810,965.228475 854.771525,1010 910,1010 C965.228475,1010 1010,965.228475 1010,910 C1010,902.5 1010,895 1007.5,887.5 L1135,760 L1210,760 L1410,560 L1260,560 L1260,410 M910,610 C744.314575,610 610,744.314575 610,910 C610,1075.68542 744.314575,1210 910,1210 C989.564947,1210 1065.87112,1178.39295 1122.13203,1122.13203 C1178.39295,1065.87112 1210,989.564947 1210,910 L1110,910 C1110,1020.45695 1020.45695,1110 910,1110 C799.54305,1110 710,1020.45695 710,910 C710,799.54305 799.54305,710 910,710 L910,610 Z",
    id: "Shape",
    fill: "#FB6340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalized);
export default __webpack_public_path__ + "static/media/personalized.0066f34420080bd2f96e609bbaf05456.svg";
export { ForwardRef as ReactComponent };